import { render, staticRenderFns } from "./WeeklyRankResult.vue?vue&type=template&id=28fb5c5a&"
import script from "./WeeklyRankResult.vue?vue&type=script&lang=js&"
export * from "./WeeklyRankResult.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyRankResult.vue?vue&type=style&index=0&id=28fb5c5a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports